export class TopicModel {
  id: string = 'xxx'
  url:  string = 'https://s3.amazonaws.com/pagewerkz-authoring/learning-object-resources/dev/uploads/resources/936b194f175d434180674b95/resources/Default.png'
  title: string = "Cell System"
  author: string = ''
  playlist: number = 8
  skill: number = 20
  description: string = 'Living things such as animals and plants are made up of cells which are the building blocks of life. They can only be seen with a microscope. Both animal and plant cells contain a cell membrane, nucleus and cytoplasm. However, plant cells have structures that animal cells do not have.';
}
